import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu } from 'antd'
import { useTranslation } from 'react-i18next';
import { useNavItemList } from '../Constants/Constants'
import NavItem from './NavItem'

const LeftBar = () => {
    const { t } = useTranslation();
    const location = useLocation()
    const navItemList = useNavItemList();

    return (
        <div className=' bg-gray-500 p-3 h-full flex overflow-y-auto w-max'>

            <div className='flex flex-col gap-2 '>
                {
                    navItemList.map((item, index) =>
                        <NavItem key={index} name={item.name} url={item.url} />
                    )
                }
            </div>
        </div>
    )
}

export default LeftBar
